import { Theme, ThemeName } from './types';

export const themes: Record<ThemeName, Theme> = {
  default: {
    logo: '/companies/ELECCTRO/logo_elecctro_colored.png',
    titleColor: '#4d4c4d',
    titleFont: 'Poppins',
    bodyFont: 'Poppins',
    cardColor: '#DCDCDC',
    cardIconColor: '#808080',
    cardTextColor: 'black',
    loadingIconColor: '#f0b239',
    buttonColor: '#f0b239',
    buttonTextColor: 'white',
    endChargeButtonColor: '#f0b239',
    linkColor: '#fac203',
    vmViewBGColor: 'linear-gradient(90deg, rgb(226, 240, 107) 0%, rgb(141,197,62) 100%)',
    vmViewTitleColor: '#4d4c4d',
    noVmViewBGColor: 'linear-gradient(90deg, rgb(255,242,170) 0%, rgb(250,194,3) 100%)',
    iconColor: 'white',
    graphicColor: '#4d4c4d',
    carChargeImage: '/companies/ELECCTRO/car_charge.webp',
    backgroundColor: 'white',
    logoFooterWhiteBG: true,
    chargeImageMarginTop: '20px',
  },
  bright: {
    logo: '/companies/BRC/bright_logo.webp',
    buttonColor: '#000f64',
    buttonTextColor: 'white',
    loadingIconColor: '#96e650',
    endChargeButtonColor: '#96e650',
    cardColor: '#4bdbc5',
    cardTextColor: 'white',
    cardIconColor: 'white',
    titleFont: 'Comfortaa',
    bodyFont: 'Mulish',
    linkColor: '#000f64',
    vmViewBGColor: 'linear-gradient(90deg, #4bdbc5 0%, #96e650 100%)',
    vmViewTitleColor: 'white',
    logoFooterMaxWidth: 150, // px
  },
  iberdrola: {
    titleFont: 'Poppins',
    bodyFont: 'Poppins',
    logo: '/companies/FCT/Iberdrola_logo.png',
    buttonColor: '#d5edfc',
    buttonTextColor: '#253284',
    loadingIcon: '/companies/FCT/LoadingIcon.svg',
    loadingIconColor: '#253284',
    cardColor: '#d4e5b5',
    cardTextColor: '#009c39',
    pinTextColor: '#253284',
    EvStationIcon: '/companies/FCT/EvStationIcon.png',
    EuroIcon: '/companies/FCT/EuroIcon.svg',
    TimerIcon: '/companies/FCT/TimerIcon.png',
    titleColor: '#009c39',
    endChargeButtonColor: '#d5edfc',
    graphic: true,
    logoFooterWhiteBG: false,
  },
  sogenave: {
    titleFont: 'Hanken Grotesk',
    bodyFont: 'Hanken Grotesk',
    logo: '/companies/SOGENAVE/mainLogo.svg',
    loginViewLogo: '/companies/SOGENAVE/sogenave.svg',
    topHeaderIcon: '/companies/SOGENAVE/headerIcon.svg',
    topHeaderTextColor: '#2AD4B7',
    buttonColor: '#2AD4B7',
    buttonTextColor: '#E6ECF0',
    linkColor: '#2AD4B7',
    vmViewBGColor: 'linear-gradient(to bottom left, #0054A6 0%, #2AD4B7 100%)',
    noVmViewBGColor: 'linear-gradient(to bottom left, #0054A6 0%, #2AD4B7 100%)',
    noVmViewButtonColor: '#2AD4B7',
    loadingIconColor: '#0054A6',
    iconColor: '#2AD4B7',
    customIcons: {
      baseUrl: '/companies/SOGENAVE/icons/',
      Candies: 'candies.svg',
      'Hot Drinks': 'hot_drinks.svg',
      Beverages: 'beverages.svg',
      Snacks: 'snacks.svg',
    },
    logoFooterMaxWidth: 200, // px
  },
  EDP: {
    titleFont: 'Mulish',
    bodyFont: 'Mulish',
    buttonColor: '#6d32ff',
    endChargeButtonColor: '#6d32ff',
    loadingIconColor: '#6d32ff',
    logo: '/companies/EDP/main_logo_small.png',
    cardColor: '#eef2f3ff',
    cardTextColor: '#222222',
    cardIconColor: '#474e55ff',
    graphic: true,
    graphicGradientStart: '#6ec4bbf3',
    graphicGradientEnd: '#6d32ff',
    linkColor: '#8351FF',
    vmViewBGColor: 'linear-gradient(135deg, #76cee9 0%, #9c8feb 100%)',
    noVmViewBGColor: 'linear-gradient(135deg, #76cee9 0%, #9c8feb 100%)',
    iconWidth: '120px',
    iconHeight: 'auto',
    carChargeImage: '/companies/EDP/car_charge.webp',
    backgroundColor: '#d7e1e3ff',
    chargeImageMarginTop: '-30px',
    logoFooterMaxWidth: 100, // px
  },
  helexia: {
    titleFont: 'Geologica',
    bodyFont: 'Geologica',
    logo: '/companies/HELEXIA/mainLogo.png',
    titleColor: '#004e74',
    buttonColor: '#004e74',
    buttonTextColor: 'white',
    endChargeButtonColor: '#fbd800',
    loadingIconColor: '#004e74',
    cardColor: '#e8e8e8',
    cardIconColor: '#004e74',
    cardTextColor: '#004e74',
    linkColor: '#004e74',
    iconColor: '#58595B',
    vmViewBGColor: 'linear-gradient(to bottom, #fcfbf9, #fbd904)',
    noVmViewBGColor: 'linear-gradient(to bottom, #fcfbf9, #fbd93c)',
    noVmViewBottomSectionColor: '#e8e8e8',
    filterButtonInactiveColor: '#8babba',
    filterButtonInactiveTextColor: 'white',
    filterButtonBorderRadius: '26px',
    actionButtonIconColor: '#004e74',
    backgroundColor: '#fcfbf9',
    topHeaderTextColor: '#0B0B0B',
    vmViewTitleColor: '#004e74',
  },
  galp: {
    // --- From Figma "Entrar" login node 76:1039 ---
    logo: '/companies/GALP/main_logo_galp.svg', // official Galp logo
    titleColor: '#0b0b0b', // Colours/Neutral/1 — "Entrar" title
    titleFont: "'Ping LCG', Poppins, sans-serif", // official Galp brand font (Ping LCG)
    bodyFont: "'Ping LCG', Poppins, sans-serif",
    buttonColor: '#be2e00', // "Registar" primary button
    buttonTextColor: 'white',
    endChargeButtonColor: '#be2e00',
    loadingIconColor: '#be2e00',
    linkColor: '#be2e00', // "Esqueci-me da palavra-passe" / "Pesquisar documentos"
    cardColor: '#f7f4ed', // login header cream, reused as neutral card
    cardTextColor: '#0b0b0b',
    cardIconColor: '#be2e00',
    // --- Derived Galp-orange (no Figma source for these screens) ---
    vmViewBGColor: '#d7cec5', // Galp payment-method screen background (taupe)
    vmViewTitleColor: '#58595b',
    noVmViewBGColor: 'linear-gradient(90deg, #ff7a00 0%, #be2e00 100%)', // derived
    iconColor: 'white',
    graphic: true, // Galp Electric is EV charging — enable the power chart
    graphicColor: '#be2e00', // derived
    graphicLineColor: '#FF5A00', // chart curve = Galp brand orange (from the logo)
    graphicGradientStart: '#ff7a00', // derived
    graphicGradientEnd: '#be2e00', // derived
    backgroundColor: 'white',
    logoFooterWhiteBG: true,
  },
};
